module.exports = __webpack_public_path__ + "static/media/whitelogo.8e989e42.png";